import { render, staticRenderFns } from "./CalendarViewWidget.vue?vue&type=template&id=9a08e7ec&scoped=true&"
import script from "./CalendarViewWidget.vue?vue&type=script&lang=js&"
export * from "./CalendarViewWidget.vue?vue&type=script&lang=js&"
import style0 from "./CalendarViewWidget.vue?vue&type=style&index=0&id=9a08e7ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a08e7ec",
  null
  
)

export default component.exports